import routeUpdateReducer from '@ane/core/lib/services/syncUrlAndStore/RouteUpdateReducer';
import { reducer as computeListReducer } from './views/ComputeList/ducks';
import { reducer as computeDeleteReducer, } from './views/ComputeList/ducks/ComputeDelete.ducks';
import { combineReducers } from 'redux';
import ComputeListReducer from './views/ComputeList/ducks/ComputeListFilter.ducks';
import { reducer as computeDetailReducer, } from './views/ComputeDetail/ducks/ComputeDetail.ducks';
import { getComputeReducer as unifiedComputeDetailReducer, } from './ducks/GetCompute.ducks';
import { getComputeListReducer as unifiedComputeListReducer, } from './ducks/GetComputeList.ducks';
import { deleteComputeReducer as unifiedComputeDeleteReducer, } from './ducks/DeleteCompute.ducks';
import { putComputeReducer as unifiedComputePutReducer, } from './ducks/PutCompute.ducks';
import computeCreateReducer from './views/ComputeCreate/ducks/ComputeCreate.ducks';
import currentUserDetailsReducersMapObject from '@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer';
import getWorkspaceReducersMapObject from '@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks';
import UserAccessReducersMapObject from '@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer';
export const moduleReducer = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, routeUpdateReducer), currentUserDetailsReducersMapObject), getWorkspaceReducersMapObject), UserAccessReducersMapObject), { computeManagementSystemModule: combineReducers({
        computeDetail: computeDetailReducer,
        computeCreate: computeCreateReducer,
        computeListState: ComputeListReducer,
        computeList: computeListReducer,
        computeDelete: computeDeleteReducer,
        unifiedComputeDetail: unifiedComputeDetailReducer,
        unifiedComputeDetailList: unifiedComputeListReducer,
        unifiedComputeDelete: unifiedComputeDeleteReducer,
        unifiedComputePut: unifiedComputePutReducer,
    }) });
export default moduleReducer;

//# sourceMappingURL=reducers.js.map
